import React from 'react';
import { InputValidationResult } from '.';

import '../translations/translations';
import { ValidatedInputProps, ValidatedTextInput } from './ValidatedTextInput';

const EmailTextInput: React.FC<ValidatedInputProps> = (props) => {
  const { inputName, required, label, autoFocus, onChange } = props;

  const emailRegExp =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

  const validateChange = (value: string): InputValidationResult => {
    let isValid = true;
    let errorMessageKey: string | undefined;

    if (required && !value) {
      isValid = false;
      errorMessageKey = 'validation.required';
    }

    if (!!value && !emailRegExp.test(value)) {
      isValid = false;
      errorMessageKey = 'validation.email_invalid';
    }

    return {
      isValid,
      errorMessageKey,
    };
  };

  return (
    <>
      <ValidatedTextInput
        inputName={inputName}
        required={required}
        autoFocus={autoFocus}
        label={label}
        type="email"
        onChange={onChange}
        onChangeValidator={validateChange}
      />
    </>
  );
};

export { EmailTextInput };
